import jwtAuthAxios from "../auth/jwtAuth";
import { setBackendDomain } from "./management";

/**
 * Fetches customers by customer_type (e.g. 2 = Obchodný partner, 3 = Servisný partner, 7 = Service partner).
 * GET /api/v1/customer/list?customer_type=<type>
 * @param {number} customerType - 2, 3, or 7
 * @returns {Promise<Array<{ id: number, company_name: string }>>}
 */
export const getCustomersByType = async (customerType) => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.get("/api/v1/customer/list", {
    params: { customer_type: customerType },
  });
  if (Array.isArray(data?.response)) return data.response;
  return [];
};

/**
 * Fetches service partners (customer_type=7) for the Service partner select.
 * @returns {Promise<Array<{ id: number, company_name: string }>>}
 */
export const getServicePartners = async () => {
  return getCustomersByType(7);
};

/**
 * Fetches business partners (customer_type=2) for the Business partner select.
 * @returns {Promise<Array<{ id: number, company_name: string }>>}
 */
export const getBusinessPartners = async () => {
  return getCustomersByType(2);
};

export const getServicePartnerCustomers = async (servicePartnerId) => {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.get("/api/v1/customer/list", {
    params: { service_partner_id: servicePartnerId },
  });
  if (Array.isArray(data?.response)) return data.response;
  return [];
};
